<template>
  <section>
    <h4>{{ title }}</h4>
    <h5 v-if="content">{{ content }}</h5>
    <h5 v-if="content2">{{ content2 }}</h5>
    <slot />
    <p v-if="note">{{ note }}</p>
  </section>
</template>

<script>
export default {
  props: ["title", "content", "content2", "note"],
}
</script>

<style lang="scss" scoped>
section {
  padding: 0 5%;
  h4 {
    margin: 20px 0 7px 0;
    font-size: 0.8rem;
  }
  h5 {
    font-size: 0.9rem;
    user-select: text;
    white-space: pre-wrap;
    line-height: 1.2;
    font-weight: normal;
    &:last-child {
      margin-bottom: 10px;
    }
  }
  p {
    font-size: 0.7rem;
    opacity: 0.5;
  }
}
</style>
